import { Fragment } from 'react'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// ** MUI Components
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider'
import Switch from '@mui/material/Switch'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view/';
import Popover from '@mui/material/Popover'
import { styled, useTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import FormHelperText from '@mui/material/FormHelperText'
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { toast, ToastContainer } from "react-toastify";
import AddIcon from '@mui/icons-material/Add';

// ** Custom Component Import
import CustomTextField from '../../../../components/mui/text-field'
import CustomAutocomplete from '../../../../components/mui/autocomplete'
// import AddIndustryDialog from 'screens/Settings/component/AddIndustry';
// import { useIndustryLogic } from 'screens/Settings/logic/industry-logic';
import { useSettingPermission } from 'screens/Settings/permissions/SettingPermissions';

// ** Icon Imports
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Icon from '../../../../components/icon';
import { stateNames, expandStateName } from '../../../../components/US_StatesNames';
import { getCounties } from '../../../../components/USTimezone_county';
import CustomLabel from 'components/CustomLabel'
import { FormLabel } from '@mui/material'
import { dev_baseUrl } from 'utils/var'
import { getTimeZone } from 'components/US_Timezones'
// import { set } from 'react-datepicker/dist/date_utils'


const StepPersonalDetails = ({handlePrev, handleNext, companyDetails, setCompanyDetails }) => {
  const theme = useTheme();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
   const [selectedIndustry, setselectedIndustry] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [errors, setErrors] = useState({});
  const timeZoneOptions = ['Eastern', 'Central', 'Mountain', 'Pacific'];
  const [industryOptions, setIndustryOptions] = useState([]);
  const [addIndustryClicked, setAddIndustryClicked] = useState(false);


  const {selectedItems, companyName, timeZone, teamSize, annualRevenue, companyAddress, street2, city, state, zipCode, country, companyEmail, companyPhone} = companyDetails;
   
   const { SettingPermissionProps } = useSettingPermission();
    const {
      hasIndustrySavePermission,
      hasIndustryGetPermission,
      hasIndustryDeletePermission,
    } = SettingPermissionProps;
  // const { IndustryProps } = useIndustryLogic(toast);
  //   const {
  //     handleOpenIndustryDlg,
  //     filteredRows,
  //     columns,
  //     paginationModel,
  //     setPaginationModel,
  //     fetchIndustries,
  //     openIndustryDlg,
  //     handleCloseIndustryDlg,
  //     rows,
  //   } = IndustryProps;
  useEffect(() => {
    if (message || Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        setMessage('');
        setErrors({});
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message, errors]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if ((companyName && companyName.length > 0) || (companyEmail && companyEmail.length > 0) || (companyPhone && companyPhone.length > 0) || (selectedItems && selectedItems.length > 0 ) || (companyAddress && companyAddress.length > 0) || (street2 && street2.length > 0) || (city && city.length > 0) || (country && country.length > 0) || (zipCode && zipCode.length > 0) || (timeZone && timeZone.length > 0) || (teamSize && teamSize.length > 0) || (annualRevenue && annualRevenue.length > 0)) {
        e.preventDefault();
        e.returnValue = ''; 
      }
    };

    const handlePopState = () => {
      if ((companyName && companyName.length > 0) || (selectedItems && selectedItems.length > 0 ) || (companyAddress && companyAddress.length > 0) || (street2 && street2.length > 0) || (city && city.length > 0) || (country && country.length > 0) || (zipCode && zipCode.length > 0) || (timeZone && timeZone.length > 0) || (teamSize && teamSize.length > 0) || (annualRevenue && annualRevenue.length > 0)) {
        const shouldNavigate = window.confirm("Are you sure you want to go back? Your changes might not be saved.");
        if (!shouldNavigate) {
          window.history.pushState(null, '', window.location.href);
        }
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [companyName,selectedItems,companyAddress,street2,city,country,zipCode,timeZone,teamSize,annualRevenue]);

  // useEffect(() => {
    
  //   const fetchIndustryData = async () => {
  //     try {
  //       const token = localStorage.getItem('jwtToken');
  //       const response = await fetch(`${dev_baseUrl}/Company/GetIndustryAndOfferings`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

    
  //       if (response.ok) {
  //         const data = await response.json();

  //         if (data.result) {
  //           const industryData = Array.from(
  //             new Map(
  //               data.result.map(item => [
  //                 item.industryID, 
  //                 { 
  //                   industryID: item.industryID, 
  //                   industryName: item.industryName 
  //                 }
  //               ])
  //             ).values()
  //           );
  //           setIndustryOptions(industryData);
  //         }
  //       } else {
  //         console.error("Failed to fetch industry data:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching industry data:", error);
  //     }
  //   };

  //   fetchIndustryData();
  // }, []);

  const navigate = useNavigate();

  const setSelectedIndustry = (item) => {
    setCompanyDetails((prevDetails) => {
      const isSelected = prevDetails.selectedItems.some(
        (i) => i.id === item.id && i.industryID === item.industryID
      );
  
      const updatedSelectedItems = isSelected
        ? prevDetails.selectedItems.filter(
            (i) => !(i.id === item.id && i.industryID === item.industryID)
          )
        : [...prevDetails.selectedItems, { id: item.id, industryID: item.industryID }];
  
      return {
        ...prevDetails,
        selectedItems: updatedSelectedItems,
      };
    });
  };
  
  const handlePrevious = () => {    
    handlePrev()
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSaveCompanyDetails = async () => {

    const isNumberOnly = (input) => {
      const numberRegex = /^\d*$/; // Matches one or more digits only
      return numberRegex.test(input);
    }
    
    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!companyEmail) newErrors.companyEmail = 'Email is required.';
    else if (!emailRegex.test(companyEmail)) newErrors.companyEmail = 'Invalid email format.';

    // Phone Number (existing)
    const phone = companyPhone;
    if (!phone || phone.trim() === '') {
      newErrors.companyPhone = 'Phone number is required';
    } else if (phone.length < 10) {
      newErrors.companyPhone = 'Invalid phone number.';
    } else if (phone.length !== 10) {
      newErrors.companyPhone = 'Phone number should be 10 digits';
    }

    if (!companyName) {
      newErrors.companyName = 'Company Name is required.';
    }

    if(companyName && companyName.trim().length < 2){
      newErrors.companyName = 'Company Name should be at least 2 characters.';
    }

    // if (!selectedItems || selectedItems.length === 0) {
    //   newErrors.industry = 'Industry selection is required.';
    // }

    if (!companyAddress) {
      newErrors.street1 = 'Street 1 is required';
    }

    if(companyAddress && companyAddress.trim().length < 2){
      newErrors.street1 = 'Street 1 should be at least 2 characters.';
    }

    if (!zipCode) {
      newErrors.zipCode = 'Zip Code is required';
    }

    if(zipCode && zipCode.trim().length < 2){
      newErrors.zipCode = 'Zip Code should be at least 2 characters.';
    }

    if (!city) {
      newErrors.city = 'City is required.';
    }

    if (!state) {
      newErrors.state = 'State is required.';
    }

    if(zipCode && !isNumberOnly(zipCode)){
      newErrors.zipCode = 'This is an invalid zip code.';
    }

    if (!timeZone) {
      newErrors.timeZone = 'Timezone is required.';
    }
    

    const validateField = (value, field) => {
      if (value && value.trim().length < 2) {
        newErrors[field] = `${field} should be at least 2 characters long.`;
      }
    };



    validateField(street2, 'street2');
    validateField(city, 'city');
    validateField(state, 'state');
    validateField(country, 'country');
    
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
     
    // const industryOfferings = selectedItems.map(item => ({
      
      
    //   // serviceOfferingID: item.id,
    //   industryID: item.industryID
    // }));
    // console.log("Selected items = ",selectedItems);
    // if (teamSize === ''){
    //   setTeamSize(null);
    // }

    // if (annualRevenue === ''){
    //   setAnnualRevenue(null);
    // }    

    // Prepare the payload for the API
    const apiPayload = {

      companyID: 0, 
      fullName: '', 
      companyName,
      companyLogo: '', 
      companyEmail, 
      companyPhone, 
      companyWebsite: '', 
      timeZone,
      annualRevenue,
      teamSize,
      street1: companyAddress,
      street2,
      city,
      state,
      zipCode,
      country,
      // industryOfferingsJSON: JSON.stringify(industryOfferings), // or use `industryOfferings` as-is if not JSON needed
      // industryOfferings
    };
  
    const token = localStorage.getItem('jwtToken');
  
    if (!token) {
      setLoading(true);
      navigate('/login', { state: { message: 'Session expired, please login again.' } });
      return;
    }
    setLoading(true);

    // console.log("Payload = "+ JSON.stringify(apiPayload));

    try {
      const response = await fetch(`${dev_baseUrl}/Company/save`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(apiPayload),
      });
      
      // console.log("Response = "+response);

      if (response.status === 400) {
        // Handle validation error
        const errorResponse = await response.json();
        console.error('Validation Error:', errorResponse);
        setMessage('Validation errors occurred. Please check your input.');
        return;
      }
  
      if (response.status === 401) {
        navigate('/login', { state: { message: 'Session expired, please login again.' } });
        return;
      }
      
      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${response.statusText}`;
        console.error(errorMessage);
        setMessage('Failed to save company data. Please try again.');
      }
  
      const result = await response.json();
      // console.log("API Response:", result);
  
      // if (result.isError) {
      
      //   setOpenErrorListDlg(true); 
      //   return;
          
      //   } else {
      
      // }

      if (response.ok) {
        setMessage('Company details saved successfully.');
        handleNext();
      } else {
        setMessage('Failed to save company details.');
      }
    } catch (error) {
      setMessage('An error occurred while saving company details.');
    } finally {
      setLoading(false);
    }
  };  
  
//  const augmentedIndustryOptions = [
//   { industryID: -1, industryName: '+ Add Industry' },
//   ...rows.map(row => ({ 
//     industryID: row.industryID, 
//     industryName: row.industryName 
//   }))
// ];

  const open = Boolean(anchorEl);
  const id = open ? 'industry-popover' : undefined;

  const handleZipCodeChange = async (value) => {
    const zipCodeRegex = /^\d{0,5}$/;
    if (zipCodeRegex.test(value)) {
      setCompanyDetails(prev => ({ ...prev, zipCode: value }));
      if (value.length === 5) {
        const timezone = await getTimeZone(value);
        const { county, city } = await getCounties(value);

        // let mappedTimezone = '';
        // if (timezone.includes('New_York') || timezone.includes('Detroit')) mappedTimezone = 'Eastern';
        // else if (timezone.includes('Chicago')) mappedTimezone = 'Central';
        // else if (timezone.includes('Denver')) mappedTimezone = 'Mountain';
        // else if (timezone.includes('Los_Angeles') || timezone.includes('Phoenix')) mappedTimezone = 'Pacific';

        setCompanyDetails(prev => ({
          ...prev,
          zipCode: value,
          country: county,
          city,
          timeZone: timezone
        }));
      }    
    }
  };
  
  
  

 return (
   <Fragment>
     <Box
       sx={{
         display: "flex",
         flexDirection: "column",
         width: "100%",
         maxWidth: "1000px",
          pt: { xs: 3, sm: "30px", md: "30px", lg: 2, xl: 2 },
         mx: "auto",
       }}
     >
       {message && (
         <Box mb={2} textAlign="left">
           <Typography
             variant="h6"
             color={message.includes("successfully") ? "green" : "red"}
           >
             {message}
           </Typography>
         </Box>
       )}
       <Box
         sx={{
           display: "flex",
           alignItems: "center",
           mb: { xs: 4, sm: 6 },
           mx: "auto",
           flexDirection: { xs: "column", sm: "row" }, // Stack on mobile
           textAlign: { xs: "center", sm: "left" }, // Center text on mobile
         }}
       >
         <Avatar
           sx={{
             bgcolor: "transparent",
             border: "1px solid #e0e0e0",
             color: "text.primary",
             mr: { xs: 0, sm: 2 }, // Remove right margin on mobile
             mb: { xs: 2, sm: 0 }, // Add bottom margin on mobile
             height: { xs: 40, sm: 50 },
             width: { xs: 40, sm: 48 },
           }}
         >
           <Icon icon="tabler:building" />
         </Avatar>
         <Box>
           <Typography
             variant="h5"
             sx={{
               mb: 0.1,
               fontSize: { xs: "1.24rem", sm: "1.24rem" },
             }}
           >
             Company Details
           </Typography>
           <Typography
             sx={{
               color: "text.secondary",
               fontSize: { xs: "0.875rem", sm: "0.9rem" },
             }}
           >
             Tell us a bit about your company
           </Typography>
         </Box>
       </Box>

       {/* Grid with two columns: Left (Details), Right (Address) */}
       <Grid container spacing={9}>
         {/* Left Column */}
         <Grid item xs={12} md={6}>
          <CustomTextField
              fullWidth
              label="Company Name"
              placeholder="Enter your company name"
              value={companyName}
               onChange={(e) => {
                const newValue = e.target.value.replace(/[0-9]/g, "");
                setCompanyDetails({ ...companyDetails, companyName: newValue });
              }}
              error={Boolean(errors.companyName)}
              helperText={errors.companyName}
              required
            />

           <Box mt={4}>
             <CustomTextField
               required
               value={companyEmail}
               fullWidth
               label="Company Email"
               placeholder="Enter your company email"
               onChange={(e) =>
                 setCompanyDetails({
                   ...companyDetails,
                   companyEmail: e.target.value,
                 })
               }
               error={Boolean(errors.companyEmail)}
               helperText={errors.companyEmail}
             ></CustomTextField>
           </Box>

           <Box mt={4}>
             <FormLabel
               required
               sx={{
                 mb: 0.8,
                 fontSize: "0.8rem",
                 fontWeight: 500,
                 color: theme.palette.text.primary,
                 "& .MuiFormLabel-asterisk": {
                   color: theme.palette.error.main,
                 },
               }}
             >
               Phone Number
             </FormLabel>
             <Box
               sx={{
                 "& .react-tel-input .form-control": {
                   width: "100%",
                   // match your TextField height (40px or 56px depending on density)
                   height: "40px",
                   borderRadius: "4px",
                   border: `1px solid ${
                     errors.companyPhone
                       ? theme.palette.error.main
                       : theme.palette.divider
                   }`,
                   backgroundColor: theme.palette.background.paper,
                   paddingLeft: "58px",
                   fontSize: "1rem",
                   fontFamily: theme.typography.fontFamily,
                   // '&:hover': {
                   //   borderColor: theme.palette.action.hover,
                   // },
                   "&:focus": {
                     borderColor: theme.palette.primary.main,
                   },
                   outline: "none",
                   "&::placeholder": {
                     color: theme.palette.text.disabled,
                     opacity: 1,
                   },
                 },
                 "& .react-tel-input .flag-dropdown": {
                   borderTopLeftRadius: theme.shape.borderRadius,
                   borderBottomLeftRadius: theme.shape.borderRadius,
                   borderRight: `1px solid ${theme.palette.divider}`,
                   backgroundColor: theme.palette.background.paper,
                 },
               }}
             >
               <PhoneInput
                 country={"us"}
                 onlyCountries={["us"]}
                 disableDropdown={true}
                 disableCountryCode={true}
                 placeholder="(702) 123-4567"
                 value={companyPhone || ""}
                 onChange={(e) =>
                   setCompanyDetails({ ...companyDetails, companyPhone: e })
                 }
                 inputClass="form-control"
                 containerStyle={{ width: "100%" }}
               />
             </Box>

             {errors.companyPhone && (
               <FormHelperText
                 sx={{
                   mt: 1,
                   ml: 0,
                   fontSize: theme.typography.body2.fontSize, // was caption → body2
                   lineHeight: theme.typography.caption.lineHeight,
                   color: theme.palette.error.main,
                 }}
               >
                 {errors.companyPhone}
               </FormHelperText>
             )}
           </Box>

           {/* <Box mt={4}>
             <CustomAutocomplete
               multiple
               options={augmentedIndustryOptions}
               getOptionLabel={(option) => option.industryName}
               value={rows.filter((option) =>
                 companyDetails.selectedItems.some(
                   (item) => item.industryID === option.industryID
                 )
               )}
               onChange={(event, newValue) => {
                 const addIndustry = newValue.find(
                   (item) => item.industryID === -1
                 );

                 if (addIndustry) {
                   handleOpenIndustryDlg(); // Trigger dialog
                   return;
                 }

                 setCompanyDetails((prev) => ({
                   ...prev,
                   selectedItems: newValue.map((option) => ({
                     industryID: option.industryID,
                   })),
                 }));

                 setErrors((prev) => ({
                   ...prev,
                   industry: newValue.length > 0 ? "" : prev.industry,
                 }));
               }}
               renderTags={(value, getTagProps) => {
                 const visible = value.slice(0, 2);
                 const extraCount = value.length - visible.length;

                 return (
                   <>
                     {visible.map((option, index) => (
                       <Chip
                         label={
                           <Typography
                             variant="body2"
                             sx={{ maxWidth: "70px", overflow: "hidden" }}
                           >
                             {option.industryName}
                           </Typography>
                         }
                         {...getTagProps({ index })}
                         key={option.industryID}
                       />
                     ))}
                     {extraCount > 0 && (
                       <Chip
                         label={`+${extraCount}`}
                         key="extra-count"
                         size="small"
                       />
                     )}
                   </>
                 );
               }}
               renderInput={(params) => (
                 <CustomTextField
                   fullWidth
                   label="Industry"
                   required
                   placeholder={
                     companyDetails.selectedItems.length > 0 ? "" : "Industries"
                   }
                   {...params}
                   error={!!errors.industry}
                 />
               )}
               renderOption={(props, option) => {
                 if (option.industryID === -1) {
                   return (
                     <li
                       {...props}
                       key="add-industry"
                       style={{
                         backgroundColor: "transparent",
                         padding: 0, // Remove default padding
                         margin: 0, // Remove default margin
                         "&:hover": {
                           backgroundColor: "transparent",
                         },
                       }}
                     >
                       <Button
                         variant="outlined"
                         startIcon={<AddIcon color="primary" />}
                         disabled={!hasIndustrySavePermission}
                         sx={{
                           backgroundColor: "white",
                           color: "text.primary",
                           textTransform: "none",
                           fontSize: "0.95rem",
                           fontWeight: 480,
                           borderRadius: "6px",
                           padding: "8px 16px",
                           borderColor: "white",
                           justifyContent: "flex-start",
                           width: "auto",
                           minWidth: "440px",
                           "&:hover": {
                             backgroundColor: "grey.200",
                             borderColor: "white",
                             color: "text.primary",
                           },
                           "&.Mui-disabled": {
                             backgroundColor: "white",
                             color: "action.disabled",
                             borderColor: "white",
                           },
                         }}
                         {...(hasIndustrySavePermission && {
                           onClick: handleOpenIndustryDlg,
                         })}
                       >
                         Add Industry
                       </Button>
                     </li>
                   );
                 }

                 return (
                   <li {...props} key={option.industryID}>
                     {option.industryName}
                   </li>
                 );
               }}
               ListboxProps={{
                 sx: {
                   maxHeight: 200,
                   overflowY: "auto",
                   mt: 1,
                   px: 2,
                 },
               }}
               disablePortal
               isOptionEqualToValue={(option, value) =>
                 option.industryID === value.industryID
               }
             />
           </Box> */}
           {/* <Box mt={4}>
          <CustomAutocomplete
              
              required
              options={['Eastern', 'Central', 'Mountain', 'Pacific']}
              id='autocomplete-timezone'
              value={companyDetails.timeZone || null}
              onChange={(event, newValue) => setCompanyDetails({ ...companyDetails, timeZone: newValue })}
              getOptionLabel={(option) => option || ''}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  label='Timezone' required
                  placeholder='Auto-fill based on zip code'
                  fullWidth
                  error={Boolean(errors.timeZone)}
                  helperText={errors.timeZone}
                />
              )}
            />
          </Box> */}
           <Box mt={4}>
             <CustomTextField
               select
               value={teamSize || "select"}
               fullWidth
               label="What's your team size?"
               onChange={(e) =>
                 setCompanyDetails({
                   ...companyDetails,
                   teamSize: e.target.value,
                 })
               }
             >
               <MenuItem disabled value="select">
                 Select
               </MenuItem>
               <MenuItem value="Self Employed">
                 Self-employed (1 person)
               </MenuItem>
               <MenuItem value="Micro">Micro (1-10 employees)</MenuItem>
               <MenuItem value="Small">Small (11-50 employees)</MenuItem>
               <MenuItem value="Medium">Medium (51-200 employees)</MenuItem>
               <MenuItem value="Large">Large (201-500 employees)</MenuItem>
               <MenuItem value="Enterprise">
                 Enterprise (501-1000 employees)
               </MenuItem>
               <MenuItem value="Corporation">
                 Corporation (1001-5000 employees)
               </MenuItem>
               <MenuItem value="Global Enterprise">
                 Global Enterprise (5001+ employees)
               </MenuItem>
             </CustomTextField>
           </Box>

           <Box mt={4}>
             <CustomTextField
               select
               value={annualRevenue || "Select"}
               fullWidth
               label="What's your estimated annual revenue?"
               onChange={(e) =>
                 setCompanyDetails({
                   ...companyDetails,
                   annualRevenue: e.target.value,
                 })
               }
             >
               <MenuItem disabled value="Select">
                 Select
               </MenuItem>
               <MenuItem value="Less than $100,000">
                 Less than $100,000
               </MenuItem>
               <MenuItem value="$100,000 - $500,000">
                 $100,000 - $500,000
               </MenuItem>
               <MenuItem value="$500,000 - $1 million">
                 $500,000 - $1 million
               </MenuItem>
               <MenuItem value="$1 million - $3 million">
                 $1 million - $3 million
               </MenuItem>
               <MenuItem value="$3 million - $5 million">
                 $3 million - $5 million
               </MenuItem>
               <MenuItem value="More than $5 million">
                 More than $5 million
               </MenuItem>
               <MenuItem value="I’d Prefer not to say">
                 Prefer not to say
               </MenuItem>
             </CustomTextField>
           </Box>
         </Grid>

         {/* Right Column: Company Address */}
         <Grid item xs={12} md={6} sx={{ pt: 0 }}>
           <CustomLabel label="Company Address" required />

           {/* Street 1 & Street 2 */}
           <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
             <CustomTextField
               fullWidth
               placeholder="Street 1"
               value={companyAddress}
               onChange={(e) => {
                 const newValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                 setCompanyDetails({
                   ...companyDetails,
                   companyAddress: newValue,
                 });
               }}
               error={Boolean(errors.street1)}
               helperText={errors.street1}
               required
             />

             <CustomTextField
               fullWidth
               placeholder="Street 2"
               value={street2}
               onChange={(e) => {
                 const newValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                 setCompanyDetails({ ...companyDetails, street2: newValue });
               }}
               error={Boolean(errors.street2)}
               helperText={errors.street2}
             />
           </Box>

           {/* Zip Code & County */}
           <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
             <CustomTextField
               fullWidth
               placeholder="Zip code"
               value={zipCode}
               onChange={(e) => handleZipCodeChange(e.target.value)}
               error={Boolean(errors.zipCode)}
               helperText={errors.zipCode}
             />
             <CustomTextField
               fullWidth               
               placeholder="County"
               value={companyDetails.country || ""}
               onChange={(e) =>
                 setCompanyDetails({
                   ...companyDetails,
                   country: e.target.value,
                 })
               }
             />
           </Box>

           {/* City & State */}
           <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
             <Box sx={{ width: "50%" }}>
               <CustomTextField
                 placeholder="City"                 
                 value={city}
                 onChange={(e) => {
                   const newValue = e.target.value.replace(
                     /[^a-zA-Z0-9\s]/g,
                     ""
                   );
                   setCompanyDetails({ ...companyDetails, city: newValue });
                 }}
                 error={Boolean(errors.city)}
                 helperText={errors.city}
                 fullWidth
               />
             </Box>
             <Box sx={{ width: "50%" }}>
              <CustomAutocomplete                
                  required
                  options={stateNames}
                  id="autocomplete-custom"
                  value={stateNames.find((option) => option === companyDetails?.state) || null}
                  onInputChange={(event, newInputValue) => {
                    const expanded = expandStateName(newInputValue);
                    setCompanyDetails((prev) => ({ ...prev, state: expanded }));
                  }}
                  onChange={(event, newValue) => {
                    setCompanyDetails((prev) => ({ ...prev, state: newValue }));
                  }}
                  getOptionLabel={(option) => option || ""}
                  renderInput={(params) => (
                    <CustomTextField
                      {...params}
                      placeholder="State"
                      error={Boolean(errors.state)}
                      helperText={errors.state}
                      fullWidth
                    />
                  )}
                />
             </Box>
           </Box>

           

           {/* Timezone - moved here */}
          <Box mt={5}>
              <CustomAutocomplete
                required                
                options={["Eastern", "Central", "Mountain", "Pacific"].sort((a, b) => a.localeCompare(b))}
                id="autocomplete-timezone"
                value={companyDetails.timeZone || null}
                onChange={(event, newValue) =>
                  setCompanyDetails({ ...companyDetails, timeZone: newValue })
                }
                getOptionLabel={(option) => option || ""}
                filterOptions={(options, { inputValue }) => {
                  const searchTerm = inputValue.toLowerCase();
                  return options.filter(option => 
                    option.toLowerCase().includes(searchTerm)
                  );
                }}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    label="Timezone"
                    required
                    placeholder="Select Timezone"
                    fullWidth
                    error={Boolean(errors.timeZone)}
                    helperText={errors.timeZone}
                  />
                )}
              />
            </Box>
         </Grid>

         <Grid item xs={12} sx={{ pt: 7 }}>
           <Box sx={{ display: "flex", alignItems: "center" }}>
             <Button
               variant="outlined"
               onClick={handlePrev}
               sx={{
                 textTransform: "none",
                 borderColor: "transparent",
                 color: "text.secondary", // Greyish color from theme
                 "&:hover": {
                   borderColor: "transparent",
                   color: "text.secondary", // Maintains grey color on hover
                 },
               }}
             >
               Previous
             </Button>

             <Box sx={{ ml: "auto" }}>
               <Button
                 variant="contained"
                 color="main"
                 disabled={loading}
                 onClick={handleSaveCompanyDetails}
                 // endIcon={
                 //   !loading ? <Icon fontSize='1.125rem' icon='tabler:arrow-right' /> : undefined
                 // }
               >
                 Next
               </Button>
             </Box>
           </Box>
         </Grid>
       </Grid>
     </Box>

     {/* <AddIndustryDialog
       open={openIndustryDlg}
       handleClose={handleCloseIndustryDlg}
       IndustryProps={IndustryProps}
     /> */}
     {/*<ToastContainer />*/}

     <Backdrop
       sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
       open={loading}
     >
       <CircularProgress color="inherit" />
     </Backdrop>
   </Fragment>
 );
}
export default StepPersonalDetails;
